module.exports = new __parcel__URL__("symbols.9147c367.png").toString();